import { Outlet } from 'react-router-dom'

import { AuthModalOverlay } from 'features/auth/AuthModalOverlay'
import { AppRequiredOverlay } from 'features/app/AppRequiredOverlay'
import { UpdateRequiredOverlay } from 'ui/UpdateRequiredWrapper/UpdateRequiredOverlay'
import { BrowserNavigationBar } from 'browser-navigation-bar'
import { TopNavBar } from 'ui/Layout/TopNavBar'

import { Sidebar } from './Sidebar/Sidebar'

export function Layout(props: { showSidebar: boolean; children?: React.ReactNode }) {
  return (
    <AuthModalOverlay>
      <UpdateRequiredOverlay>
        <AppRequiredOverlay>
          <BrowserNavigationBar />
          <TopNavBar />
          <div className="flex mt-2">
            {props.showSidebar && <Sidebar className="w-60  flex-shrink-0" />}
            <main className="px-6 pb-0 flex-grow">
              <Outlet />
            </main>
          </div>
        </AppRequiredOverlay>
      </UpdateRequiredOverlay>
    </AuthModalOverlay>
  )
}
